import { gql } from '@apollo/client';

export const GET_CATEGORY = gql`
  query GetCategories($input: GetCategoriesInput) {
    getCategories(input: $input) {
      results {
        _id
        name
        status
        createdAt
      }
      totalCount
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      success
      message
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      success
      message
    }
  }
`;

export const CHANGE_CATEGORY_STATUS = gql`
  mutation ChangeCategoryStatus($input: ChangeCategoryStatusInput!) {
    changeCategoryStatus(input: $input) {
      success
      message
    }
  }
`;